(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminTaskDisplaySettingsController', AdminTaskDisplaySettingsController);

    function AdminTaskDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        $translate,
        recurrenceRulesService,
        assetScoreTypesCollection,
        contractManager,
        elbSettings,
        $state,
        module,
        modulesService,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'task_force_service_routine'
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            $translate: $translate,
            recurrenceRulesService: recurrenceRulesService,
            assetScoreTypesCollection: assetScoreTypesCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService,
            fileTypeService: fileTypeService
        });

        angular.extend(vm, base);
    }
})();
